/* src/app/components/user/Notes/styles.js */

export default theme => {
  const { unit } = theme.spacing;
  const space = unit * 3;

  return {
    card: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: unit * 100,
      height: unit * 80,
    },
    cell: {
      padding: unit,
      paddingLeft: space,
      paddingRight: space,
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
    },
    icon: {
      marginRight: unit,
    },
    textWrapper: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      marginRight: space,
      justifyContent: 'center',
    },
    dateAuthor: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    body: {
      overflow: 'auto',
      height: '67%',
      backgroundColor: theme.palette.background.default,
    },
    footer: {
      padding: space,
    },
    buttonContainer: {
      display: 'flex',
      paddingTop: unit * 2,
    },
    button: {
      marginLeft: 'auto',
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/components/user/Notes/styles.js